/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Pocket = [
  ["path", { d: "M20 3a2 2 0 0 1 2 2v6a1 1 0 0 1-20 0V5a2 2 0 0 1 2-2z" }],
  ["path", { d: "m8 10 4 4 4-4" }]
];

export { Pocket as default };
//# sourceMappingURL=pocket.js.map
